module.exports = __webpack_public_path__ + "img/Atu.91f55e2b.jpg";